import { makeGetRequest } from 'owa-ows-gateway';
import { PremiumUserResponse } from '../contracts/premiumUserResponse';

const getSecondarySubscribersUrl: string = 'ows/api/beta/PremiumUser/secondarysubscribers';

export async function getSecondarySubscribers(): Promise<PremiumUserResponse[]> {
    let response = await makeGetRequest(getSecondarySubscribersUrl);
    return response;
}
